import { StudentResultSheetModelType } from '@models/StudentResultSheet';
import { StudentResultModelType } from '@models/StudentResult';

interface GetStudentResultArgs {
  studentResultSheet: StudentResultSheetModelType;
  batchSubjectExtraSlotId: string;
  assessmentId: string;
}

export const getStudentResult = ({
  batchSubjectExtraSlotId,
  studentResultSheet,
  assessmentId,
}: GetStudentResultArgs): StudentResultModelType => {
  if (assessmentId) {
    return studentResultSheet.studentResults.find((studentResult) => studentResult.assessmentId === assessmentId);
  }

  return studentResultSheet.studentResults.find(
    (studentResult) => studentResult.batchSubjectExtraSlotId === batchSubjectExtraSlotId,
  );
};

export const getStudentResultWithGrade = (
  calculatedTotal: number | 'NYC' | 'PC' | '-',
  withMarks = true,
  isPC = false,
): string => {
  let grade: string;
  let displayGradeOnly = false
  if (calculatedTotal === '-') {
    grade = '-';
  } else if (calculatedTotal === 'NYC') {
    grade = 'NYC';
    displayGradeOnly = true;
  } else if (calculatedTotal === 'PC' || isPC) {
    grade = 'PC';
    displayGradeOnly = true;
  } else if (calculatedTotal >= 80) {
    grade = 'A';
  } else if (calculatedTotal >= 70) {
    grade = 'B';
  } else if (calculatedTotal >= 60) {
    grade = 'C';
  } else {
    grade = 'NYC';
  }

  return withMarks && !displayGradeOnly ? `${calculatedTotal} - ${grade}` : grade;
};
